var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 1.6665C14.6028 1.6665 18.3337 5.39734 18.3337 9.99984C18.3337 14.6023 14.6028 18.3332 10.0003 18.3332C5.39783 18.3332 1.66699 14.6023 1.66699 9.99984C1.66699 5.39734 5.39783 1.6665 10.0003 1.6665ZM10.0003 3.33317C8.23222 3.33317 6.53652 4.03555 5.28628 5.28579C4.03604 6.53603 3.33366 8.23173 3.33366 9.99984C3.33366 11.7679 4.03604 13.4636 5.28628 14.7139C6.53652 15.9641 8.23222 16.6665 10.0003 16.6665C11.7684 16.6665 13.4641 15.9641 14.7144 14.7139C15.9646 13.4636 16.667 11.7679 16.667 9.99984C16.667 8.23173 15.9646 6.53603 14.7144 5.28579C13.4641 4.03555 11.7684 3.33317 10.0003 3.33317ZM10.0003 4.99984C10.2044 4.99986 10.4014 5.0748 10.554 5.21043C10.7065 5.34607 10.8039 5.53296 10.8278 5.73567L10.8337 5.83317V9.65484L13.0895 11.9107C13.2389 12.0606 13.3257 12.2619 13.3322 12.4735C13.3386 12.6851 13.2643 12.8913 13.1243 13.0501C12.9843 13.2089 12.789 13.3084 12.5783 13.3285C12.3675 13.3486 12.157 13.2877 11.9895 13.1582L11.9112 13.089L9.41116 10.589C9.28164 10.4594 9.19846 10.2907 9.17449 10.109L9.16699 9.99984V5.83317C9.16699 5.61216 9.25479 5.4002 9.41107 5.24392C9.56735 5.08763 9.77931 4.99984 10.0003 4.99984Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time-icon.8bee348bec2e51274f244febacfbdbcc.svg";
export { ForwardRef as ReactComponent };